<div class="mt-5">
    <div class="top-header-wrap">
        <div class="row">
            <div class="col-md-12 col-lg-12 col-xl-12">
                <div class="d-flex align-items-center justify-content-end">
                    <div class="d-flex search-wrapper pb-3">
                        <mat-form-field floatLabel="never">
                            <input
                                matInput
                                type="text"
                                placeholder="Enter a search Item"
                                [(ngModel)]="searchText"
                                (ngModelChange)="searchTextChanged()"
                                autocomplete="off"
                            />
                            <button mat-button matPrefix mat-icon-button class="search_btn">
                                <mat-icon class="serach_icon">search</mat-icon>
                            </button>
                        </mat-form-field>
                    </div>

                    <div class="custom_pagination custom-pagination-wrap">
                        <mat-paginator [pageSize]="pageSize" [length]="totalData" showFirstLastButtons> </mat-paginator>
                    </div>

                    <div class="custom-icon-wrapper">
                        <a
                            href="javascript:void(0)"
                            #tooltip="matTooltip"
                            matTooltip="Insert New Item"
                            matTooltipPosition="above"
                            (click)="viewDetail(null, 'Add')"
                        >
                            <i class="mdi mdi-table-plus"></i
                        ></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="row">
    <div class="col-md-12 grid-view">
        <div class="mat-elevation-z8 table_responsive">
            <table mat-table [dataSource]="dataSource" class="w-100 mat-table-wrapper">
                <ng-container matColumnDef="{{ column }}" *ngFor="let column of displayedColumns">
                    <th mat-header-cell *matHeaderCellDef>
                        <div class="d-flex align-items-center position-relative">
                            {{ column }}
                            <div *ngIf="parentColumns.includes(column)">
                                <a cdkOverlayOrigin #trigger="cdkOverlayOrigin" (click)="optionlistclick(column, trigger)">
                                    <i class="mdi mdi-filter-variant" [class.filter-apply]="activeFilters.includes(column)"></i>
                                </a>
                                <ng-template
                                    cdk-connected-overlay
                                    [cdkConnectedOverlayOrigin]="overlayOrigin"
                                    [cdkConnectedOverlayOpen]="filterOpen"
                                    [cdkConnectedOverlayPositions]="overlayPositions"
                                    (backdropClick)="closeFilter()"
                                    [cdkConnectedOverlayHasBackdrop]="true"
                                >
                                    <app-filter-options
                                        *ngIf="selectedTableFilter?.title == column"
                                        [optionList]="selectedTableFilter?.data"
                                        [selectedValues]="selectdOptions"
                                        (selectedOptions)="onSelectedOptions($event)"
                                        (cancelOptions)="onCancelOption($event)"
                                        [totalData]="totalData"
                                    ></app-filter-options>
                                </ng-template>
                            </div>
                        </div>
                    </th>
                    <ng-container *ngIf="!(childColumns.includes(column) || parentColumns.includes(column))">
                        <td mat-cell *matCellDef="let element">{{ element[column] }}</td>
                    </ng-container>
                    <ng-container *ngIf="parentColumns.includes(column)">
                        <td mat-cell class="childTable" *matCellDef="let element" (click)="openParentDetails(column, element)">{{ element[column] }}</td>
                    </ng-container>
                    <ng-container *ngIf="childColumns.includes(column)">
                        <td mat-cell class="childTable" *matCellDef="let element" (click)="openChildDetails(column, element)">{{ column }}</td>
                    </ng-container>
                </ng-container>

                <ng-container matColumnDef="action">
                    <th mat-header-cell *matHeaderCellDef>action</th>
                    <td mat-cell *matCellDef="let row">
                        <div class="icon-wrapper">
                            <a href="javascript:void(0)" #tooltip="matTooltip" matTooltip="Edit" matTooltipPosition="above" (click)="viewDetail(row, 'Edit')">
                                <i class="fas fa-pen"> </i
                            ></a>
                            <a href="javascript:void(0)" #tooltip="matTooltip" matTooltip="Delete" matTooltipPosition="above" (click)="deleteDetail(row)">
                                <i class="fas fa-trash"> </i
                            ></a>
                            <a
                                href="javascript:void(0)"
                                #tooltip="matTooltip"
                                matTooltip="View"
                                matTooltipPosition="above"
                                (click)="viewDetail(row, 'Details')"
                            >
                                <i class="fas fa-eye"> </i
                            ></a>
                        </div>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

                <tr class="mat-row" *matNoDataRow>
                    <td class="mat-cell error-message" [attr.colspan]="displayedColumns.length" *ngIf="dataSource.data.length <= 0">
                        <div *ngIf="!searchText">No data available.</div>
                        <div *ngIf="searchText">No data matching "{{ searchText }}"</div>
                    </td>
                </tr>
            </table>
        </div>
    </div>
</div>
